<script setup>
const uid = useId()
const ids = {
  soft: `n705-soft-${uid}`,
  vivid: `n705-vivid-${uid}`,
  wave: `n705-wave-${uid}`,
  bandG: `n705-band-g-${uid}`,
  band: `n705-band-${uid}`,
}
</script>

<template>
  <svg
    role="img"
    aria-label="wave pulse icon"
    class="wave-pulse"
    xmlns="http://www.w3.org/2000/svg"
    width="203"
    height="21.5"
    viewBox="0 0 203 21.5"
    fill="none"
  >
    <title>Wave Pulse</title>
    <defs>
      <linearGradient
        :id="ids.soft"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="203"
        y2="0"
      >
        <stop offset="0" stop-color="#9DAEEA" />
        <stop offset="0.08" stop-color="#9FB2E7" />
        <stop offset="0.22" stop-color="#B1BEF2" />
        <stop offset="0.45" stop-color="#B5C2F3" />
        <stop offset="0.62" stop-color="#B1BDEF" />
        <stop offset="0.82" stop-color="#8E93CF" />
        <stop offset="1" stop-color="#8C9CD4" />
      </linearGradient>
      <linearGradient
        :id="ids.vivid"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="203"
        y2="0"
      >
        <stop offset="0" stop-color="#48D6FA" />
        <stop offset="0.08" stop-color="#49E5BE" />
        <stop offset="0.22" stop-color="#9DD6AA" />
        <stop offset="0.45" stop-color="#BDCCA5" />
        <stop offset="0.62" stop-color="#D4B8AA" />
        <stop offset="0.82" stop-color="#EE5DEA" />
        <stop offset="1" stop-color="#B083F7" />
      </linearGradient>
      <mask
        :id="ids.wave"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="203"
        height="21.5"
      >
        <path
          d="M -45.385 1 c 5.618 0 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5"
          stroke="#fff"
          fill="none"
          stroke-width="2"
          stroke-linecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            from="0 0"
            to="30.923 0"
            dur="1.8s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="d"
            dur="5.4s"
            repeatCount="indefinite"
            calcMode="spline"
            keyTimes="0;0.5;1"
            keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
            values="M -45.385 1 c 5.618 0 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5;M -45.385 5.387 c 5.618 0 9.843 10.725 15.462 10.725 s 9.843 -10.725 15.462 -10.725 s 9.843 10.725 15.462 10.725 s 9.843 -10.725 15.462 -10.725 s 9.843 10.725 15.462 10.725 s 9.843 -10.725 15.462 -10.725 s 9.843 10.725 15.462 10.725 s 9.843 -10.725 15.462 -10.725 s 9.843 10.725 15.462 10.725 s 9.843 -10.725 15.462 -10.725 s 9.843 10.725 15.462 10.725 s 9.843 -10.725 15.462 -10.725 s 9.843 10.725 15.462 10.725 s 9.843 -10.725 15.462 -10.725 s 9.843 10.725 15.462 10.725 s 9.843 -10.725 15.462 -10.725 s 9.843 10.725 15.462 10.725 s 9.843 -10.725 15.462 -10.725 s 9.843 10.725 15.462 10.725;M -45.385 1 c 5.618 0 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5 s 9.843 -19.5 15.462 -19.5 s 9.843 19.5 15.462 19.5"
          />
        </path>
      </mask>
      <linearGradient :id="ids.bandG" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#fff" stop-opacity="0" />
        <stop offset="0.45" stop-color="#fff" stop-opacity="1" />
        <stop offset="0.55" stop-color="#fff" stop-opacity="1" />
        <stop offset="1" stop-color="#fff" stop-opacity="0" />
      </linearGradient>
      <mask
        :id="ids.band"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="203"
        height="21.5"
      >
        <rect
          x="-104"
          y="0"
          width="100"
          height="21.5"
          :fill="`url(#${ids.bandG})`"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            from="0 0"
            to="311 0"
            dur="6.5s"
            repeatCount="indefinite"
          />
        </rect>
      </mask>
    </defs>
    <rect
      x="0"
      y="0"
      width="203"
      height="21.5"
      :fill="`url(#${ids.soft})`"
      :mask="`url(#${ids.wave})`"
    />
    <g :mask="`url(#${ids.wave})`">
      <rect
        x="0"
        y="0"
        width="203"
        height="21.5"
        :fill="`url(#${ids.vivid})`"
        :mask="`url(#${ids.band})`"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.transcript-icon {
  height: 28px;
  width: 28px;
}
</style>
